import { Flex, HStack, LinkProps, Text } from '@chakra-ui/react';
import { ELegalLinks } from '@olo-web/types/enums';
import React from 'react';
import { FooterLink } from '../FooterLink';

const commonLinkStyles: LinkProps = {
  textAlign: 'center',
  mx: 1,
  color: 'blackAlpha.400',
  fontSize: { base: 'xs', md: 'sm' },
};

export const RecaptchaTerms = () => (
  <Flex
    width="100%"
    justifyContent="center"
    alignItems="center"
    flexWrap={{ base: 'wrap', sm: 'nowrap' }}
    px={2}
    fontSize={{ base: 'xs', md: 'sm' }}
  >
    <Text
      as="span"
      color="blackAlpha.400"
      textAlign="center"
      whiteSpace={{ base: 'normal', sm: 'nowrap' }}
    >
      This site is protected by reCAPTCHA and the Google{' '}
    </Text>
    <HStack as="ul" display="inline-flex" alignItems="center" listStyleType="none">
      <FooterLink
        linkStyles={commonLinkStyles}
        linkText="Privacy Policy"
        linkHref={ELegalLinks.RECAPTCHA_PRIVACY_POLICY}
      />
    </HStack>
    <Text as="span"> and </Text>
    <HStack as="ul" display="inline-flex" alignItems="center" listStyleType="none">
      <FooterLink
        linkStyles={commonLinkStyles}
        linkText="Terms of Service"
        linkHref={ELegalLinks.RECAPTCHA_TERMS_OF_SERVICE}
      />
    </HStack>
    <Text as="span"> apply.</Text>
  </Flex>
);
